import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchVersions, fetchVersionsApi} from '../actions/version'
import Version from '../components/Version'

const mapStateToProps = state => {
  const { version } = state
  const {
    isFetching,
    lastUpdated,
    items,
  } = version || {
    isFetching: true,
    items: []
  }

  return {
    items,
    isFetching,
    lastUpdated
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getVersions: fetchVersions,
      getApiVersions: fetchVersionsApi,
      // getVersionsOs:fetchVersionsOs
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Version)
